import styled from 'styled-components';
import Typography from '../../shared/typography/Typography';

export const DescriptionContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: start !important;
  justify-content: start;
  gap: 97px;
  padding-right: 97px;

  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    gap: 25%;
    flex-wrap: wrap;
    padding: 0;
  }

  .description-column{
    width: 100%;
  }
`;

export const StyledTypography = styled(Typography)`
  &.title {

    @media screen and (max-width: 670px) {
      font-size: 20px !important;
      line-height: 30px !important;
    }
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  gap: 16px;
  margin-right: 97px;
    
  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    margin: 10px;
  }
  `;